// Métadonnées légères : les gros JSON ne sont plus intégrés au bundle principal.

const templatesRaw = {
  // Nouveau modèle : ajoutez isNew: true sur sa définition.
  hermes: { name: "Hermes" },
  dior: { name: "Dior" },
  galerieslafayette: { name: "Galeries Lafayette" },
  celine: { name: "Celine" },
  balenciaga: { name: "Balenciaga" },
  lacoste: { name: "Lacoste" },
  fnac: { name: "Fnac" },
  footlocker: { name: "Foot Locker" },
  citadium: { name: "Citadium" },
  intersport: { name: "Intersport" },
  moncler: { name: "Moncler" },
  printemps: { name: "Printemps" },
  louisvuitton: { name: "Louis Vuitton" },
  sephora: { name: "Sephora" },
  yvessaintlaurent: { name: "Yves Saint Laurent" },
  swatch: { name: "Swatch" },
  basket4ballers: { name: "Basket4Ballers" },
  gucci: { name: "Gucci" },
  miumiu: { name: "Miu Miu" },
  burberry: { name: "Burberry" },
  stockx: { name: "StockX" },
  chanel: { name: "Chanel" },
  polene: { name: "Polene" },
  jdsport: { name: "JD Sport" },
};

export const templates = Object.fromEntries(
  Object.entries(templatesRaw).sort(
    ([, a], [, b]) =>
      a.name.localeCompare(
        b.name,
        'fr',
        { sensitivity: 'base' }
      )
  )
);

const templateLoaders = {
  hermes: () => import('./hermes.json'),
  dior: () => import('./dior.json'),
  galerieslafayette: () => import('./galerieslafayette.json'),
  celine: () => import('./celine.json'),
  balenciaga: () => import('./balenciaga.json'),
  lacoste: () => import('./lacoste.json'),
  fnac: () => import('./fnac.json'),
  footlocker: () => import('./footlocker.json'),
  citadium: () => import('./citadium.json'),
  intersport: () => import('./intersport.json'),
  moncler: () => import('./moncler.json'),
  printemps: () => import('./printemps.json'),
  louisvuitton: () => import('./louisvuitton.json'),
  sephora: () => import('./sephora.json'),
  yvessaintlaurent: () => import('./yvessaintlaurent.json'),
  swatch: () => import('./swatch.json'),
  basket4ballers: () => import('./basket4ballers.json'),
  gucci: () => import('./gucci.json'),
  miumiu: () => import('./miumiu.json'),
  burberry: () => import('./burberry.json'),
  stockx: () => import('./stockx.json'),
  chanel: () => import('./chanel.json'),
  polene: () => import('./polene.json'),
  jdsport: () => import('./jdsport.json'),
};

export const loadTemplate = async (id) => {
  const loader =
    templateLoaders[id] ||
    templateLoaders.hermes;

  const module = await loader();

  return module?.default ?? module;
};

export const getTemplate = (id) =>
  templates[id] || templates.hermes;

export default templates;